import { connect } from 'react-redux';
import Dashboard from './components/Dashboard';
import { selectDashboards } from '../../redux/selectors/dashboards';
import {
  createDashboard,
  loadWidgets,
  updateDashboard,
  loadDashboardDetails,
  updateDashboardCell,
} from '../../redux/actions/dashboards';

const mapStateToProps = (state, props) => {
  const dashboardsById = state.dashboards.dashboardsById;
  const id = props.match?.params?.id;
  const dashboard = dashboardsById[id];
  return {
    dashboard,
    dashboards: selectDashboards(state),
    widgets: state.dashboards.widgets,
  };
};

const mapDispatchToProps = {
  createDashboard,
  loadWidgets,
  loadDashboardDetails,
  updateDashboard,
  updateDashboardCell,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
